import React from 'react';
import {Avatar} from '@mui/material';
import {getKBImage} from "../KB/KBImage.js";
import {fromWebBot} from "../App/utils.js";
import {kbBackgroundOpacity} from "../App/theme";

export const ChatAvatarBackground = ({kbId, publishedKbId, backgroundOpacity}) => {
    const imageId = publishedKbId || kbId;
    return (
        <div className="chat-background-image">
            <Avatar
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${getKBImage(imageId)})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    opacity: backgroundOpacity || (fromWebBot ? 0.12 : kbBackgroundOpacity),
                    zIndex: 0,
                    pointerEvents: 'none',
                    borderRadius: '0%'
                }}
                alt="AI" src={getKBImage(imageId)}
            />
        </div>
    )
}